import {
  ActionType,
  Choice,
  ContentType,
  DiagnosticsActionStatus,
  NodeType,
  OutcomeSignal,
  ParamOrVar,
  Target,
} from '@ems/yoda-ux';
import { CustomerSupportRequestState, RequestSeverity, RequestCreatedBy, RequestModality, FreelanceRequest } from './requestModels';

export enum RaiseEventNames {
  SignIn = 'signin',
  ContactSupport = 'contactsupport',
  FeedbackCamera = 'FeedbackHub-Camera'
}

/**
 * Attribute type and name to add to html element.
 * If Index is provided the value will be prefixed by the index number: Example id = "test-1"
 */
export interface LoggingHtmlAttribute {
  Name: string;
  Value: string;
  Indexed?: boolean;
}

/**
 * Text field class with content type and content.
 * Used for providing any form of text to be renderd in component
 */
export class TextField {
  public contentType!: ContentType;
  public content!: string;
}

/**
 * Base type for all intent graph nodes
 */
export interface GraphNode {
  actionType?: ActionType;
  actionReference?: string;
  timeoutSeconds?: number;
  parameters?: ParamOrVar;
  variables?: ParamOrVar;
  targets?: Target;
  defaultTargetNodeId?: string;
  failedTargetNodeId?: string;
  successTargetNodeId?: string;
  payload?: string;
  dynamicChoiceTargetNodeId?: string;
  staticChoices?: Choice;
  dynamicChoicesList: Choice[];
  question?: TextField;
  title?: TextField;
  type?: NodeType;
  id?: string;
  name?: string;
  tags?: string;
  text?: TextField;
  outcomeSignal?: OutcomeSignal;
  dynamicChoices?: boolean;
  selectedChoice?: Choice;
  diagnosticsActionStatus?: DiagnosticsActionStatus;
  timerId?: number;
}

export class SearchRequestsRequestModel {
  public Query: string;
  public Product: string;
  public State: CustomerSupportRequestState;
  public Severity: RequestSeverity;
  public Modality: RequestModality;
  public CreatedBy: RequestCreatedBy;
  public PageIndex: number;
  public PageSize: number;
  public PageKey: string;
  public ExportResolutionSteps: boolean;
  public LookBackDays: number;

  public constructor() {
    this.Query = '';
    this.Product = '';
    this.State = CustomerSupportRequestState.All;
    this.Severity = RequestSeverity.None;
    // this.Modality = RequestModality.Undefined;
    // this.CreatedBy = RequestCreatedBy.Tenant;
    this.PageIndex = 0;
    this.PageSize = 50;
    this.PageKey = '';
    // this.ExportResolutionSteps = false;
    this.LookBackDays = -1;
  }
}

export type SearchRequestsResponseModel = {
   TotalPageCount: number;
   Results: FreelanceRequest[];
   PageIndex: number;
   PageKey: string;
   Type: string;
}

export class AriaRoles {
  public static Alert = 'alert';
  public static Button = 'button';
  public static Group = 'group';
  public static Heading = 'heading';
  public static List = 'list';
  public static ListItem = 'listitem';
  public static TabList = 'tablist';
}
